import { Col, Divider, Row } from 'antd';
import classNames from 'classnames/bind';
import styled from 'styled-components';
import styles from './DetailInfoClientOrder.module.scss';

const cx = classNames.bind(styles);

const Item = styled.div`
    .ant-divider-horizontal {
        margin: 14px 0px;
    }
`;

const DetailInfoClientOrder = ({ item }) => {
    return (
        <Item>
            <div className={cx('container')}>
                <Row align="middle" className={cx('name_section')}>
                    Delivery information
                </Row>
                <Divider style={{ borderTop: '2px solid rgba(0,0,0,.06)' }} />
                <Row align="middle">
                    <Col xs={4}>
                        <Row className={cx('label')}>Name: </Row>
                    </Col>
                    <Col xs={20}>
                        <Row className={cx('content')} justify="end">
                            {item.fullname}
                        </Row>
                    </Col>
                </Row>
                <Divider style={{ borderTop: '2px solid rgba(0,0,0,.06)' }} />
                <Row align="middle">
                    <Col xs={10}>
                        <Row className={cx('label')}>Phone number: </Row>
                    </Col>
                    <Col xs={14}>
                        <Row className={cx('content')} justify="end">
                            {item.phone}
                        </Row>
                    </Col>
                </Row>
                <Divider style={{ borderTop: '2px solid rgba(0,0,0,.06)' }} />
                {item.order_type === 'PRODUCT' ? (
                    <>
                        <Row align="middle">
                            <Col xs={10}>
                                <Row className={cx('label')}>Address: </Row>
                            </Col>
                            <Col xs={14}>
                                <Row className={cx('content')} justify="end">
                                    {item.address}
                                    {item.ward ? `, ${item.ward}` : ''}
                                    {item.district ? `, ${item.district}` : ''}
                                    {item.city ? `, ${item.city}` : ''}
                                </Row>
                            </Col>
                        </Row>
                        <Divider style={{ borderTop: '2px solid rgba(0,0,0,.06)' }} />
                    </>
                ) : null}

                <Row align="middle">
                    <Col xs={10}>
                        <Row className={cx('label')}>Note: </Row>
                    </Col>
                    <Col xs={14}>
                        <Row className={cx('content')} justify="end">
                            {item.note}
                        </Row>
                    </Col>
                </Row>
                <Divider style={{ borderTop: '2px solid rgba(0,0,0,.06)' }} />
                <Row align="middle">
                    <Col xs={10}>
                        <Row className={cx('label')}>Branch: </Row>
                    </Col>
                    <Col xs={14}>
                        <Row className={cx('content')} justify="end">
                            {item?.branch?.name}
                        </Row>
                    </Col>
                </Row>
            </div>
        </Item>
    );
};

export default DetailInfoClientOrder;
